import React from "react";
import { pluralize } from "../utils/pluralize";
import SlidingContainer from "./SlidingContainer";

export interface TakeawayItem {
  id: string;
  title: string;
  hasResponses?: boolean;
  responseCount?: number;
  onActionClick?: () => void;
}

interface KeyTakeawaysListProps {
  takeaways: TakeawayItem[];
  actionLabel?: string;
  className?: string;
  actionButtonClassName?: string;
  indicatorClassName?: string;
  showTutorial?: boolean;
}

export default function KeyTakeawaysList({
  takeaways,
  actionLabel = "View Responses",
  className = "",
  actionButtonClassName = "max-w-32",
  indicatorClassName = "",
  showTutorial = false,
}: KeyTakeawaysListProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      {takeaways.map((takeaway, index) => (
        <SlidingContainer
          key={takeaway.id}
          title={takeaway.title}
          hasAction={takeaway.hasResponses}
          actionLabel={
            takeaway.responseCount && takeaway.responseCount > 0 ? (
              <span>
                {actionLabel}
                <br />
                <span className="text-xs text-white">
                  ({pluralize("Response", takeaway.responseCount, true)})
                </span>
              </span>
            ) : (
              actionLabel
            )
          }
          onActionClick={takeaway.onActionClick}
          indicatorClassName={indicatorClassName}
          actionButtonClassName={actionButtonClassName}
          showTutorial={showTutorial && index === 0}
        />
      ))}
    </div>
  );
}
